import React from 'react';
import { SvgIcon } from '@mui/material';
import PropTypes from 'prop-types';

const FeedbackIcon = (props) => (
  <SvgIcon {...props}>
    <path
      d="M9 3C5.134 3 2 5.686 2 9C2 10.127 2.369 11.1771 3 12.0781V15.7168C3 16.2458 3.60434 16.5485 4.02734 16.2305L6.28906 14.5332C7.12206 14.8332 8.039 15 9 15C12.866 15 16 12.314 16 9C16 5.686 12.866 3 9 3ZM17.9766 8.57422C17.9846 8.71622 18 8.857 18 9C18 13.411 13.963 17 9 17C8.98 17 8.96041 16.9961 8.94141 16.9961C10.1514 18.7891 12.409 20 15 20C15.961 20 16.8769 19.8332 17.7109 19.5332L19.9746 21.2305C20.3966 21.5475 21 21.2448 21 20.7168V17.0781C21.631 16.1771 22 15.127 22 14C22 11.6 20.3526 9.53422 17.9766 8.57422Z"
      fill={props.sx?.color || '#080F1D'}
    />
  </SvgIcon>
);

FeedbackIcon.propTypes = {
  sx: PropTypes.object,
};

export default FeedbackIcon;
